import axiosInstance from '../Api/axiosInstance';

// Get all todos for a user and company
export const getPublicTodos = (userId, companyId, scope = 'mine') =>
	axiosInstance.get('/todos', { params: { userId, companyId, scope } });

// Get todos specific to the logged-in user
export const getUserTodos = (userId, companyId) =>
	axiosInstance.get('/todos/myTodos', { params: { userId, companyId } });

// Get a specific todo by ID
export const getTodoById = (id, userId, companyId) =>
	axiosInstance.get(`/todos/${id}`, { params: { userId, companyId } });

// Create a new todo
export const createTodo = (todoData, userId, companyId) =>
	axiosInstance.post('/todos', todoData, { params: { userId, companyId } });

// Update an existing todo by ID
export const updateTodo = (id, todoData, userId, companyId) =>
	axiosInstance.put(`/todos/${id}`, todoData, {
		params: { userId, companyId },
	});

// Delete a todo by ID
export const deleteTodo = (id, userId, companyId) =>
	axiosInstance.delete(`/todos/${id}`, { params: { userId, companyId } });
